import {types} from './report.actions';

const initialState = {
    pedidosAguardPlanejamento: { 
        countPedidosAguaPlanejamento: 0, 
        filters: {
            carrier: {
                documentNumber: null,
                name: "TODOS",
            },
            period: {
                description:"Últimos 7 dias",
                period: "LAST_SEVEN_DAYS"
            },
        },
        lookup:{
            showCarrier: false,
            showPeriod: false,
            columnsCarrier:[
                {
                    field: "razaoSocial",
                    header: "Razão social",
                    columnKey: "razaoSocial",
                    sortable: false,
                    filter: true
                   
                  }
            ],
            columnsPeriod:[
                {
                    field: "description",
                    header: "Período",
                    columnKey: "description",
                    sortable: false,
                    filter: true
                   
                  }
            ]
        }
    }
}

export function reducerPedidosAguardPlanejamento(state = initialState, action){
    let result = state;
    switch(action.type){
        case types.SET_VALUE:
            return setValue(state, action);
        case types.SET_NAME:
            return setName(state, action);
        case types.SET_CNPJ:
            return setCNPJ(state, action);
        case types.SET_PERIOD:
            return setPeriod(state, action);
        case types.SET_SHOW_CARRIER:
            return setShowCarrier(state, action);
        case types.SET_SHOW_PERIOD:
            return setShowPeriod(state, action);   
        case types.LOADER_SHOW:
            return loaderShow(state, action);
        case types.LOADER_HIDDEN:
            return loaderHide(state, action);                   
        default:
        return result; 
    }
}

function setValue(state, action){
    const pedidosAguardPlanejamento = {...state.pedidosAguardPlanejamento, countPedidosAguaPlanejamento:action.value}
    return Object.assign({}, state, {pedidosAguardPlanejamento});
}

function setName(state, action){
    return Object.assign({}, state, { value: action.name }); 
}

function setCNPJ(state, action){
    const filters = {...state.pedidosAguardPlanejamento.filters,carrier:action.carrier}
    const pedidosAguardPlanejamento = {...state.pedidosAguardPlanejamento, filters}
    return Object.assign({}, state, {pedidosAguardPlanejamento}); 
}

function setPeriod(state, action){
    const filters = {...state.pedidosAguardPlanejamento.filters, period:action.period}
    const pedidosAguardPlanejamento = {...state.pedidosAguardPlanejamento, filters}
    return Object.assign({}, state, {pedidosAguardPlanejamento});  
}

function setShowCarrier(state, action){
    const lookup = {...state.pedidosAguardPlanejamento.lookup, showCarrier:action.showCarrier}
    const pedidosAguardPlanejamento = {...state.pedidosAguardPlanejamento, lookup}
    return Object.assign({}, state, {pedidosAguardPlanejamento}); 
}

function setShowPeriod(state, action){
    const lookup = {...state.pedidosAguardPlanejamento.lookup, showPeriod:action.showPeriod}
    const pedidosAguardPlanejamento = {...state.pedidosAguardPlanejamento, lookup}
    return Object.assign({}, state, {pedidosAguardPlanejamento}); 
}

function loaderShow(state, action){
    return Object.assign({}, state, { value: action.show }); 
}

function loaderHide(state, action){
    return Object.assign({}, state, { value: action.show }); 
}

